export const PREFER_NEW_PURCHASE_ORDER_WORKFLOW_KEY =
  '@@loaded/workflow/prefer-new-purchase-order'
